import { authHeader, handleResponse } from "../helpers";
export const PaymentApprovalService = {
  getCategory,
  createCategory,
  createSubCategory,
  updateCategory,
  SubUpdateCategory,
  inActiveRow,
  approveUser,
  inActiveRow2,
  getSubCategory,
  fetchCategoryDLL,
  fetchSubCategoryDLL,
};

function approveUser(userId) {
  const requestOptions = {
      method: 'GET',
      headers: authHeader()
  };
  return fetch(`${process.env.REACT_APP_API_URL}UserMaster/ApproveUser/${userId}`, requestOptions)
      .then(handleResponse);
}

function getCategory(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}DealerPayment/GetPaymentDealer`,
    requestOptions
  ).then(handleResponse);
}

function getSubCategory(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}CategoryMaster/GetSubCategory`,
    requestOptions
  ).then(handleResponse);
}

function createCategory(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}CategoryMaster/InsertExtraBenefit`,
    requestOptions
  ).then(handleResponse);
}
function createSubCategory(data) {
  console.log(data);
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}CategoryMaster/CreateSubCategory`,
    requestOptions
  ).then(handleResponse);
}
function updateCategory(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}CategoryMaster/InsertExtraBenefit`,
    requestOptions
  ).then(handleResponse);
}
function SubUpdateCategory(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}CategoryMaster/SubUpdateCategory`,
    requestOptions
  ).then(handleResponse);
}

function inActiveRow(DealerId, isActive) {
  debugger
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}DealerPayment/InActiveRow/${DealerId}/${isActive}`,
    requestOptions
  ).then(handleResponse);
}
function inActiveRow2(categoryId, isActive) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}DealerPayment/InActiveRow/${categoryId}/${isActive}`,
    requestOptions
  ).then(handleResponse);
}

function fetchCategoryDLL() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}CategoryMaster/GetCategoryDLL`,
    requestOptions
  ).then(handleResponse);
}
function fetchSubCategoryDLL(data) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}CategoryMaster/GetSubCategoryDLL?categoryId=${data}`,
  ).then(handleResponse);
}
